import { DataView24 } from "@carbon/icons-react";
import {
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from "carbon-components-react";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";

const tableHeaders = [
  {
    header: "Candidatura",
    key: "code",
  },
  {
    header: "Data da avaliação",
    key: "evaluationDate",
  },
  {
    header: "Pontuação",
    key: "scores",
  },

  {
    header: "Total",
    key: "totalScore",
  },
  {
    header: "Conversão",
    key: "conversion",
  },
  {
    header: "Consultar",
    key: "actions",
  },
];

const LinkList = ({ url }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url} title="Consultar">
        <DataView24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  // if (cell.info.header === "hasBusinessCurrently") {
  //   return cell.value ? "Sim" : "Não";
  // }

  // if (cell.info.header === "totalScore") {
  //   return cell.value
  //     ? parseFloat((parseFloat(cell.value).toFixed(2) / 20) * 100).toFixed(2) +
  //         "%"
  //     : "";
  // }
  if (cell.info.header === "actions") {
    return <LinkList url={"../candidatura-juri/" + id} />;
  }
  return cell.value;
};

const ApplicationEvaluationPage = () => {
  const { user, isJury } = useContext(AuthContext);
  const [apps, setApps] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);

  const navigate = useNavigate();

  const featchData = async () => {
    try {
      const response = await http.get(
        `/applications/jury-applications/filter?username=${user.username}&size=${size}`
      );
      // getApplicationData(response);
      transformData(response);
      // console.log(response.data.content);
      // setApps(response.data.content);
      // setCount(response.data.totalElements);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      var pag = page - 1;
      const response = await http.get(
        `/applications/jury-applications/filter?username=${user.username}&page=${pag}&size=${pageSize}`
      );
      // setApps(response.data.content);
      // setCount(response.data.totalElements);
      transformData(response);
    } catch (error) {}
  };

  const search = async (phoneNumber1) => {
    try {
      const response = await http.get(
        "/applications/search/filter?competitor.phoneNumber1=" + phoneNumber1
      );
      setApps(response.data.content);
      // getApplicationData(response);
    } catch (error) {}
  };

  const transformData = (response) => {
    const data = response.data.content.map((item) => ({
      id: item.id,
      code: item.id.substring(0, 8),
      evaluationDate: item.evaluationDate
        ? new Date(item.evaluationDate).toLocaleDateString("pt-PT")
        : "",
      scores: item.scores?.join(", "),
      totalScore: item.totalScore ? parseFloat(item.totalScore).toFixed(2) : "",
      conversion: item.totalScore
        ? parseFloat(
            (parseFloat(item.totalScore).toFixed(2) / 20) * 100
          ).toFixed(2) + "%"
        : "",
    }));
    setApps(data);
    setCount(response.data.totalElements);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Avaliação de Candidaturas">
      <DataTable rows={apps} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default ApplicationEvaluationPage;
